import React from 'react'
import styled from 'styled-components'
import AppLayout from '~/components/appLayout'
import DashboardItem from '~/packages/dashboard/dashboardItem.component'
import DashboardGridItemShortcuts from '~/packages/dashboard/gridItems/dashboardGridItemShortcuts.component'
import DashboardGridItemCourseDropout from '~/packages/dashboard/gridItems/dashboardGridItemCourseDropout.component'
import DashboardGridItemCourseLifeCycle from '~/packages/dashboard/gridItems/dashboardGridItemCourseLifeCycle.component'
import DashboardGridItemServiceIntegrationsMonitoring from '~/packages/dashboard/gridItems/dashboardGridItemServiceIntegrationsMonitoring.component'
import DashboardGridItemSubnormalClusters from '~/packages/dashboard/gridItems/dashboardGridItemSubnormalClusters.component'
import DashboardGridItemStandardPortfolioReport from '~/packages/dashboard/gridItems/dashboardGridItemStandardPortfolioReport.component'
import { trackAnalyticsEvent } from '~/utils/client/analytics'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: stretch;
  background: #ffffff;
  padding: 0;
`

const Content = styled.div`
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: start;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    max-width: 760px;
    margin: 0 auto;
    gap: 16px;
  }
`

const LeftColumn = styled.div`
  grid-column: 1 / span 8;
  background: #ffffff;
  padding: 24px 24px 48px;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 1200px) {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    padding: 16px 16px 0;
    gap: 16px;
  }

  @media (max-width: 920px) {
    grid-template-columns: 1fr;
  }
`

const RightPane = styled.div`
  grid-column: 9 / -1;
  background: #e0e5eb;
  padding: 24px 24px 48px;

  align-self: stretch;

  @media (max-width: 1200px) {
    grid-column: 1 / -1;
    border-left: none;
    background: #ffffff;
    padding: 0 16px 24px;
  }
`

export default function ExtraScreen() {
  React.useEffect(() => {
    trackAnalyticsEvent('study_list_opened', {
      source_screen: 'study_list',
    })
  }, [])

  return (
    <AppLayout title='Links úteis e estudos' dockActive='studies-and-links'>
      <Wrapper>
        <Content>
          <LeftColumn>
            <DashboardItem
              title='Relatório Padrão de Monitoramento de Portfólios'
              component={<DashboardGridItemStandardPortfolioReport />}
              kind='aside'
            />
            <DashboardItem
              title='Monitoramento das Integrações dos Atendimentos'
              component={<DashboardGridItemServiceIntegrationsMonitoring />}
              kind='aside'
            />
            <DashboardItem
              title='Ciclo de Vida do Produto'
              component={<DashboardGridItemCourseLifeCycle />}
              kind='aside'
            />
            <DashboardItem
              title='Aglomerados Subnormais'
              component={<DashboardGridItemSubnormalClusters />}
              kind='aside'
            />
            <DashboardItem
              title='Evasão de Cursos'
              component={<DashboardGridItemCourseDropout />}
              kind='aside'
            />
          </LeftColumn>

          <RightPane>
            <DashboardItem
              title='Links e Atalhos Úteis'
              component={<DashboardGridItemShortcuts />}
              kind='aside'
            />
          </RightPane>
        </Content>
      </Wrapper>
    </AppLayout>
  )
}
